import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import React, { useState } from 'react';
import CloseIcon from '@/assets/icon/close.svg';
import LeftArrowIcon from '@/assets/icon/ic_angle_bracket_left.svg';
import RightArrowIcon from '@/assets/icon/ic_angle_bracket_right.svg';
import { color } from '@/constant/color';
import * as S from './ConquererMonthlyScreen.style';
import ConqueredList from './sections/ConqueredList';
dayjs.extend(objectSupport);
export default function ConquererMonthlyScreen({ route, navigation, }) {
    const [month, setMonth] = useState(route.params.initialMonth);
    const [year, setYear] = useState(route.params.initialYear);
    function prevMonth() {
        if (month === 1) {
            setYear(year - 1);
            setMonth(12);
        }
        else {
            setMonth(month - 1);
        }
    }
    function nextMonth() {
        if (month === 12) {
            setYear(year + 1);
            setMonth(1);
        }
        else {
            setMonth(month + 1);
        }
    }
    const canGoBack = dayjs({ year, month }).isAfter(dayjs({ year: 2023, month: 5 }));
    const canGoNext = dayjs({ year, month }).isBefore(dayjs());
    return (_jsxs(S.ConquererMonthlyScreen, { children: [_jsx(S.Header, { children: _jsx(S.CloseButton, { elementName: "conquerer_monthly_close_button", onPress: navigation.goBack, children: _jsx(CloseIcon, { width: 20, height: 20, color: color.gray90 }) }) }), _jsxs(S.MonthSelector, { children: [_jsx(S.MoveMonthButton, { elementName: "conquerer_monthly_prev_month", onPress: prevMonth, disabled: !canGoBack, children: _jsx(LeftArrowIcon, { width: 24, height: 24, color: canGoBack ? color.brandColor : color.gray70 }) }), _jsxs(S.CurrentMonth, { children: [year, ". ", month.toString().padStart(2, '0')] }), _jsx(S.MoveMonthButton, { elementName: "conquerer_monthly_next_month", onPress: nextMonth, disabled: !canGoNext, children: _jsx(RightArrowIcon, { width: 24, height: 24, color: canGoNext ? color.brandColor : color.gray70 }) })] }), _jsx(ConqueredList, { year: year, month: month })] }));
}
